/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Button, Col, DatePicker, Form, Input, Modal, Row, Select, Typography, Upload, notification } from 'antd';
import BookingDropdowns from './BookingDropdowns';
import Loader from '../../../../components/common/Loader';
import { AddBooking, addPaymentTransactionService } from '../../../../services/admin-services';
import { API_RESPONSE_CODES } from '../../../../utills/constant';
import InputSelect from '../../../../components/common/InputSelect';
import UploadButton from '../../../../components/common/UploadButton';
import { fetchLeadDetailsServices, handleTabChange } from '../../../auth/slice/authSlice';
import {
  getInsuranceCostService,
  getInsuranceTypeService,
  getRoadTaxCostService,
  getRoadTaxTypeService,
  getRtoService,
  getVehicleModelService,
} from '../../../../services/master-services';
import {
  formatIndianCurrency,
  notRequiredPriceValidationFunction,
  priceValidationFunction,
} from '../../../../utills/helpers';
import BookingDetails from './BookingDetails';
import TransactionModal from '../TransactionModal';

const { Title } = Typography;

const Bookings = (props) => {
  const { editBooking, setEditBooking, bookingDetailsShow, setBookingDetailsShow, isExchangeEvaluationTeam } = props;
  const { id } = useParams();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const dateFormat = 'DD/MM/YYYY';

  const leadViewDetails = useSelector((state) => state?.auth?.leadDetails);
  const [rtoData, setRtoData] = useState([]);
  const [modalData, setModalData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [foreClosure, setForeClosure] = useState('');
  const [showOdometer, setShowOdometer] = useState(false);
  const [roadTaxCost, setRoadTaxCost] = useState(leadViewDetails?.booking?.road_tax);
  const [insuranceCost, setInsuranceCost] = useState(leadViewDetails?.booking?.insurance);
  const [roadTaxTypeData, setRoadTaxTypeData] = useState([]);
  const [insuranceTypeData, setInsuranceTypeData] = useState([]);
  const [customerAgreeToExc, setCustomerAgreeToExc] = useState();
  const [excVehicleIds, setExcVehicleIds] = useState({
    make_id: leadViewDetails?.vehicle_detail?.model?.make_id || '',
    model_id: leadViewDetails?.vehicle_detail?.model?.id || '',
    vehicle_variant_id: leadViewDetails?.vehicle_detail?.vehicle_variant_id || '',
    color_type_id: leadViewDetails?.vehicle_detail?.color_id || '',
    fuel_type_id: leadViewDetails?.vehicle_detail?.fuel_type_id || '',
    seater_id: leadViewDetails?.vehicle_detail?.seater_id || '',
  });

  const [fileList, setFileList] = useState({
    copy_of_rc: [],
    copy_of_insurance: [],
    copy_of_mr: [],
    copy_of_foreclosure_statement: [],
    copy_of_order_booklet: [],
  });

  const [tcsValue, setTcsValue] = useState(0);
  const [total, setTotal] = useState(leadViewDetails?.booking?.on_road_price || 0);
  const [totalOffer, setTotalOffer] = useState(leadViewDetails?.booking?.total_deal_offer || 0);
  const [totalCustomerPay, setTotalCustomerPay] = useState(leadViewDetails?.booking?.total_customer_payable || 0);

  // When no booking: which quotation to copy from (default = newest). Used for price + vehicle details.
  const [selectedQuotationId, setSelectedQuotationId] = useState(null);

  // Transaction Modal state
  const [transactionForm] = Form.useForm();
  const [isTransactionModalOpen, setIsTransactionModalOpen] = useState(false);
  const [isTransactionSaveLoading, setIsTransactionSaveLoading] = useState(false);
  const [transactionFile, setTransactionFile] = useState([]);

  const handleCustomerAgreeChange = (value) => {
    setShowOdometer(value === 'Yes');
  };

  useEffect(() => {
    if (id) {
      dispatch(fetchLeadDetailsServices({ id: id }));
    }
  }, [id]);

  useEffect(() => {
    if (vehicleDataEntered) {
      form.setFieldsValue({
        road_tax: null,
        insurance: null,
      });
    }
  }, [excVehicleIds]);

  useEffect(() => {
    calculateTotal(form.getFieldsValue());
  }, [showOdometer, insuranceCost, roadTaxCost, customerAgreeToExc, excVehicleIds]);

  useEffect(() => {
    const customerAgreeToExchange = leadViewDetails?.exchange_vehicle_detail?.customer_agree_to_exchange;
    setShowOdometer(customerAgreeToExchange === 'Yes');
  }, []);

  // Quotations sorted by newest first (for default selection and dropdown)
  const sortedQuotations = useMemo(
    () =>
      [...(leadViewDetails?.quotations || [])].sort(
        (a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0)
      ),
    [leadViewDetails?.quotations]
  );

  // When no booking exists but quotations exist, use selected quotation (or newest) for price + vehicle
  const getPriceSourceForForm = (quotationId) => {
    if (leadViewDetails?.booking) {
      return { source: 'booking', data: leadViewDetails.booking };
    }
    if (sortedQuotations?.length > 0) {
      const selected =
        quotationId != null
          ? leadViewDetails?.quotations?.find((q) => q.id === quotationId)
          : null;
      const data = selected || sortedQuotations[0];
      return { source: 'quotation', data };
    }
    return { source: null, data: null };
  };

  // Default selected quotation to newest when no booking and quotations exist
  useEffect(() => {
    if (
      !leadViewDetails?.booking &&
      sortedQuotations?.length > 0 &&
      selectedQuotationId == null
    ) {
      setSelectedQuotationId(sortedQuotations[0].id);
    }
  }, [leadViewDetails?.booking, sortedQuotations, selectedQuotationId]);

  useEffect(() => {
    if (!leadViewDetails?.id) return;
    const { source, data: priceData } = getPriceSourceForForm(selectedQuotationId);

    getRtoLocation(leadViewDetails?.customer?.state?.id);
    getModalData(leadViewDetails?.exchange_vehicle_detail?.make_id);

    // Common price fields between quotation and booking - use booking when exists, else last quotation when no booking
    const commonPriceFields = priceData
      ? {
          tentative_accessories: priceData.tentative_accessories ?? 0,
          amc: priceData.amc ?? 0,
          fastag: priceData.fastag ?? 0,
          road_tax: priceData.road_tax ?? 0,
          road_tax_type_id: priceData.road_tax_type_id ?? null,
          ew: priceData.ew ?? 0,
          body_care_3m: priceData.body_care_3m ?? 0,
          tcs: priceData.tcs ?? 0,
          on_road_price: priceData.on_road_price ?? 0,
          logistic_charges: priceData.logistic_charges ?? 0,
          insurance: priceData.insurance ?? 0,
          insurance_type_id: priceData.insurance_type_id ?? null,
          ex_showroom_price: priceData.ex_showroom_price ?? 0,
          cost_of_registration: priceData.cost_of_registration ?? 0,
          rto_cost: priceData.rto_cost ?? 0,
          rto_location_id:
            source === 'booking'
              ? leadViewDetails?.customer?.rto_location_id || priceData.rto_location_id
              : priceData.rto_location_id ?? leadViewDetails?.customer?.rto_location_id ?? null,
        }
      : {
          tentative_accessories: 0,
          amc: 0,
          fastag: 0,
          road_tax: 0,
          road_tax_type_id: null,
          ew: 0,
          body_care_3m: 0,
          tcs: 0,
          on_road_price: 0,
          logistic_charges: 0,
          insurance: 0,
          insurance_type_id: null,
          ex_showroom_price: 0,
          cost_of_registration: 0,
          rto_cost: 0,
          rto_location_id: leadViewDetails?.customer?.rto_location_id ?? null,
        };

    // Booking-only fields: use booking when exists, else 0
    const bookingOnlyFields = leadViewDetails?.booking
      ? {
          consumer_offer: leadViewDetails.booking.consumer_offer ?? 0,
          exchange_offer: leadViewDetails.booking.exchange_offer ?? 0,
          corporate_offer: leadViewDetails.booking.corporate_offer ?? 0,
          other_oem_offer: leadViewDetails.booking.other_oem_offer ?? 0,
          total_deal_offer: leadViewDetails.booking.total_deal_offer ?? 0,
          insurance_company: leadViewDetails.booking.insurance_company ?? '',
          handling_charges: leadViewDetails.booking.handling_charges ?? 0,
          choice_number_charges: leadViewDetails.booking.choice_number_charges ?? 0,
          other_dealer_offer: leadViewDetails.booking.other_dealer_offer ?? 0,
          additional_discount: leadViewDetails.booking.additional_discount ?? 0,
          total_customer_payable: leadViewDetails.booking.total_customer_payable ?? 0,
          discount_approval_insurance: leadViewDetails.booking.discount_approval_insurance ?? 0,
        }
      : {
          consumer_offer: 0,
          exchange_offer: 0,
          corporate_offer: 0,
          other_oem_offer: 0,
          total_deal_offer: 0,
          insurance_company: '',
          handling_charges: 0,
          choice_number_charges: 0,
          other_dealer_offer: 0,
          additional_discount: 0,
          total_customer_payable: leadViewDetails?.booking?.total_customer_payable ?? 0,
          discount_approval_insurance: 0,
        };

    // Vehicle details: when copying from quotation use quotation keys (API: vehicle_model_id, model.make_id, etc.); else use lead vehicle_detail
    const vehicleDetail = leadViewDetails?.vehicle_detail;
    const quotationVehicle = source === 'quotation' && priceData ? priceData : null;
    const vehicleModelId =
      quotationVehicle?.vehicle_model_id ?? quotationVehicle?.model?.id ?? vehicleDetail?.model?.id;
    const vehicleVariantId =
      quotationVehicle?.vehicle_variant_id ?? vehicleDetail?.vehicle_variant_id;
    const vehicleColorId =
      quotationVehicle?.color_id ?? vehicleDetail?.color_id;
    const vehicleFuelTypeId =
      quotationVehicle?.fuel_type_id ?? vehicleDetail?.fuel_type_id;
    const vehicleSeaterId =
      quotationVehicle?.seater_id ?? vehicleDetail?.seater_id;
    const vehicleMakeId =
      quotationVehicle?.model?.make_id ?? vehicleDetail?.model?.make_id;

    const nextExcVehicleIds = {
      make_id: vehicleMakeId ?? '',
      model_id: vehicleModelId ?? '',
      vehicle_variant_id: vehicleVariantId ?? '',
      color_type_id: vehicleColorId ?? '',
      fuel_type_id: vehicleFuelTypeId ?? '',
      seater_id: vehicleSeaterId ?? '',
    };
    setExcVehicleIds(nextExcVehicleIds);

    form.setFieldsValue({
      ...leadViewDetails,
      ...commonPriceFields,
      ...bookingOnlyFields,
      vehicle_model_id: vehicleModelId,
      vehicle_variant_id: vehicleVariantId,
      color_id: vehicleColorId,
      fuel_type_id: vehicleFuelTypeId,
      seater_id: vehicleSeaterId,
      exchange_vehicle_model_id: leadViewDetails?.exchange_vehicle_detail?.model?.id,
      exchange_car: leadViewDetails?.exchange_car,
      choice_vehicle_no: leadViewDetails?.choice_vehicle_no,
      value_offered: leadViewDetails?.exchange_vehicle_detail?.value_offered || 0,
      social_occassion: leadViewDetails?.social_occassion,
      odometer: leadViewDetails?.exchange_vehicle_detail?.odometer,
      year: leadViewDetails?.exchange_vehicle_detail?.car_year
        ? dayjs(leadViewDetails?.exchange_vehicle_detail?.car_year)
        : '',
      expected_delivery_date: leadViewDetails?.expected_delivery_date
        ? dayjs(leadViewDetails?.expected_delivery_date)
        : '',
      foreclosure_cost: leadViewDetails?.exchange_vehicle_detail?.foreclosure_cost || 0,
      hypothecation_on_care: leadViewDetails?.exchange_vehicle_detail?.hypothecation_on_care,
      customer_agree_to_exchange: leadViewDetails?.exchange_vehicle_detail?.customer_agree_to_exchange,
      foreclosure_responsibility: leadViewDetails?.exchange_vehicle_detail?.foreclosure_responsibility
        ? leadViewDetails?.exchange_vehicle_detail?.foreclosure_responsibility
        : null,
      vehicle_handed_over_to_exchange_team:
        leadViewDetails?.exchange_vehicle_detail?.vehicle_handed_over_to_exchange_team,
    });

    if (priceData) {
      setRoadTaxCost(priceData.road_tax ?? 0);
      setInsuranceCost(priceData.insurance ?? 0);
      setTotal(priceData.on_road_price ?? 0);
      setTotalCustomerPay(leadViewDetails?.booking?.total_customer_payable ?? 0);
      setTotalOffer(leadViewDetails?.booking?.total_deal_offer ?? 0);
    }

    setCustomerAgreeToExc(
      leadViewDetails?.exchange_vehicle_detail?.customer_agree_to_exchange === 'Yes' ? true : false
    );
    setUploadComponentData(leadViewDetails?.documents);
    getInsuranceTypeData();
    getRoadTaxTypeData();
  }, [leadViewDetails, selectedQuotationId]);

  const getRtoLocation = async (id) => {
    setIsLoading(true);
    try {
      const response = await getRtoService(id);
      setRtoData(response?.data?.data);
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const convertUrlToBlob = async (url) => {
    if (!url) return null;
    try {
      const response = await fetch(url);
      return await response.blob();
    } catch (error) {
      return null;
    }
  };

  const getModalData = async (value) => {
    setIsLoading(true);
    try {
      const modalDataArray = await getVehicleModelService(value);
      setModalData(modalDataArray?.data?.data);
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const setUploadComponentData = (imagesData) => {
    const formattedFileLists = {
      copy_of_rc: [],
      copy_of_mr: [],
      copy_of_insurance: [],
      copy_of_foreclosure_statement: [],
      copy_of_order_booklet: [],
    };

    imagesData?.forEach((doc) => {
      const file = {
        uid: doc.id,
        name: doc.document_file_name,
        status: 'done',
        url: doc.document_path,
      };

      switch (doc.document_type) {
        case 'RC':
          formattedFileLists.copy_of_rc.push(file);
          break;
        case 'Insurance Policy':
          formattedFileLists.copy_of_insurance.push(file);
          break;
        case 'Old Car Foreclosure Statement':
          formattedFileLists.copy_of_foreclosure_statement.push(file);
          break;
        case 'MR Copy':
          formattedFileLists.copy_of_mr.push(file);
          break;
        case 'Order Booklet Copy':
          formattedFileLists.copy_of_order_booklet.push(file);
          break;
        default:
          break;
      }
    });

    setFileList(formattedFileLists);
  };

  const handleStatusTracker = (key) => {
    form.setFieldsValue({ status: key });
  };

  const getRoadTaxTypeData = async () => {
    setIsLoading(true);
    try {
      const roadTaxData = await getRoadTaxTypeService();
      setRoadTaxTypeData(roadTaxData?.data?.data);
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getInsuranceTypeData = async () => {
    setIsLoading(true);
    try {
      const insuranceData = await getInsuranceTypeService();
      setInsuranceTypeData(insuranceData?.data?.data);
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const onSubmit = async (values) => {
    setIsLoading(true);
    const formData = new FormData();
    const status = form.getFieldValue('status');

    formData.append('lead_id', id);
    formData.append('status', status ? status : '');
    formData.append('ew', values?.ew ? values?.ew : 0);
    formData.append('tcs', values?.tcs ? values?.tcs : 0);
    formData.append('amc', values?.amc ? values?.amc : 0);
    formData.append('fastag', values?.fastag ? values?.fastag : 0);
    formData.append('odometer', values?.odometer ? values?.odometer : '');
    formData.append('color_id', values?.color_id ? values?.color_id : '');
    formData.append('road_tax', values?.road_tax ? values?.road_tax : 0);
    formData.append('seater_id', values?.seater_id ? values?.seater_id : '');
    formData.append('insurance', values?.insurance ? values?.insurance : 0);
    formData.append('insurance_company', values?.insurance_company ? values?.insurance_company : '');
    formData.append('handling_charges', values?.handling_charges ? values?.handling_charges : 0);
    formData.append('choice_number_charges', values?.choice_number_charges ? values?.choice_number_charges : 0);
    formData.append('rto_cost', values?.rto_cost ? values?.rto_cost : 0);
    formData.append('road_tax_type_id', values?.road_tax_type_id ? values?.road_tax_type_id : '');
    formData.append('insurance_type_id', values?.insurance_type_id ? values?.insurance_type_id : 0);
    formData.append('year', values?.year ? dayjs(values.year).format('YYYY') : null);
    formData.append('body_care_3m', values?.body_care_3m ? values?.body_care_3m : 0);
    formData.append('exchange_car', values?.exchange_car ? values?.exchange_car : '');
    formData.append('value_offered', values?.value_offered ? values?.value_offered : 0);
    formData.append('on_road_price', values?.on_road_price ? values?.on_road_price : 0);
    formData.append('consumer_offer', values?.consumer_offer ? values?.consumer_offer : 0);
    formData.append('exchange_offer', values?.exchange_offer ? values?.exchange_offer : 0);
    formData.append('other_oem_offer', values?.other_oem_offer ? values?.other_oem_offer : 0);
    formData.append('corporate_offer', values?.corporate_offer ? values?.corporate_offer : 0);
    formData.append('rto_location_id', values?.rto_location_id ? values?.rto_location_id : '');
    formData.append('foreclosure_cost', values?.foreclosure_cost ? values?.foreclosure_cost : 0);
    formData.append('total_deal_offer', values?.total_deal_offer ? values?.total_deal_offer : 0);
    formData.append('logistic_charges', values?.logistic_charges ? values?.logistic_charges : 0);
    formData.append('social_occassion', values?.social_occassion ? values?.social_occassion : '');
    formData.append('choice_vehicle_no', values?.choice_vehicle_no ? values?.choice_vehicle_no : '');
    formData.append('ex_showroom_price', values?.ex_showroom_price ? values?.ex_showroom_price : 0);
    formData.append('other_dealer_offer', values?.other_dealer_offer ? values?.other_dealer_offer : 0);
    formData.append('additional_discount', values?.additional_discount ? values?.additional_discount : 0);
    formData.append('cost_of_registration', values?.cost_of_registration ? values?.cost_of_registration : 0);
    formData.append('fuel_type_id', values?.fuel_type_id ? values?.fuel_type_id : '');
    formData.append('tentative_accessories', values?.tentative_accessories ? values?.tentative_accessories : 0);
    formData.append('hypothecation_on_care', values?.hypothecation_on_care ? values?.hypothecation_on_care : '');
    formData.append('total_customer_payable', values?.total_customer_payable ? values?.total_customer_payable : 0);
    formData.append(
      'exchange_vehicle_model_id',
      values?.exchange_vehicle_model_id ? values?.exchange_vehicle_model_id : ''
    );
    formData.append('vehicle_model_id', values?.vehicle_model_id ? values?.vehicle_model_id : '');
    formData.append(
      'foreclosure_responsibility',
      values?.foreclosure_responsibility ? values?.foreclosure_responsibility : ''
    );
    formData.append(
      'customer_agree_to_exchange',
      values?.customer_agree_to_exchange ? values?.customer_agree_to_exchange : ''
    );
    formData.append('vehicle_variant_id', values?.vehicle_variant_id ? values?.vehicle_variant_id : '');
    formData.append(
      'discount_approval_insurance',
      values?.discount_approval_insurance ? values?.discount_approval_insurance : 0
    );
    formData.append(
      'vehicle_handed_over_to_exchange_team',
      values?.vehicle_handed_over_to_exchange_team ? values?.vehicle_handed_over_to_exchange_team : ''
    );
    formData.append(
      'expected_delivery_date',
      values?.expected_delivery_date ? dayjs(values?.expected_delivery_date).format('YYYY-MM-DD') : null
    );
    const appendFile = async (key, files) => {
      if (files?.length > 0) {
        const file = files[0].originFileObj || (await convertUrlToBlob(files[0].url));
        formData.append(key, file || '');
      } else {
        formData.append(key, '');
      }
    };
    await appendFile('copy_of_rc', fileList.copy_of_rc);
    await appendFile('copy_of_mr', fileList.copy_of_mr);
    await appendFile('copy_of_insurance', fileList.copy_of_insurance);
    await appendFile('copy_of_order_booklet', fileList.copy_of_order_booklet);
    await appendFile('copy_of_foreclosure_statement', fileList.copy_of_foreclosure_statement);

    try {
      const response = await AddBooking(formData);
      dispatch(fetchLeadDetailsServices({ id: id }));
      if (response.data.status === API_RESPONSE_CODES?.OK || response.data.status === API_RESPONSE_CODES?.CREATED) {
        notification.success({
          message: response.data.message,
        });

        const status = form.getFieldValue('status');
        if (status === 'Booked') {
          // Booking API is successful here.
          // Keep Bookings mounted so we can show confirm + transaction modal from this component.
          if (typeof setEditBooking === 'function') {
            setEditBooking(true);
          }
          setBookingDetailsShow(false);

          // Only show the modal if booking amount has NOT been received yet
          if (!leadViewDetails?.booking_amount_received) {
            Modal.confirm({
              title: 'Booking Successful!',
              content: 'Do you want to add booking amount now?',
              okText: 'Add Booking Amount',
              cancelText: 'Add Later',
              onOk: () => {
                // Open transaction modal from Bookings
                setIsTransactionModalOpen(true);
              },
              onCancel: () => {
                // User chose to skip transaction – show booking details view
                if (typeof setEditBooking === 'function') {
                  setEditBooking(false);
                }
                setBookingDetailsShow(true);
              },
            });
          } else {
            // Booking amount already received - just show booking details
            if (typeof setEditBooking === 'function') {
              setEditBooking(false);
            }
            setBookingDetailsShow(true);
          }
        } else {
          // Status is not Booked - just show booking details
          if (typeof setEditBooking === 'function') {
            setEditBooking(false);
          }
          setBookingDetailsShow(true);
        }
      }
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    if (editBooking) {
      setEditBooking(false);
      setBookingDetailsShow(true);
    } else {
      form.resetFields();
      setFileList({
        copy_of_rc: [],
        copy_of_mr: [],
        copy_of_insurance: [],
        copy_of_order_booklet: [],
        copy_of_foreclosure_statement: [],
      });
    }
  };

  const handleInsuranceTypeChange = async (val) => {
    const payload = {
      vehicle_model_id: excVehicleIds?.model_id,
      vehicle_variant_id: excVehicleIds?.vehicle_variant_id,
      fuel_type_id: excVehicleIds?.fuel_type_id,
      seater_id: excVehicleIds?.seater_id,
      color_id: excVehicleIds?.color_type_id,
      insurance_type_id: val ? val : leadViewDetails?.booking?.insurance_type_id,
    };
    const insuranceCost = await getInsuranceCostService(payload);
    if (insuranceCost.data.status === API_RESPONSE_CODES.OK) {
      setInsuranceCost(insuranceCost?.data?.data);
      form.setFieldsValue({
        insurance: insuranceCost?.data?.data,
      });
    }
  };

  const handleRoadTaxTypeChange = async (val) => {
    const payload = {
      vehicle_model_id: excVehicleIds?.model_id,
      vehicle_variant_id: excVehicleIds?.vehicle_variant_id,
      fuel_type_id: excVehicleIds?.fuel_type_id,
      seater_id: excVehicleIds?.seater_id,
      color_id: excVehicleIds?.color_type_id,
      road_tax_id: val ? val : leadViewDetails?.booking?.insurance_type_id,
    };
    const roadTaxTypeCost = await getRoadTaxCostService(payload);
    if (roadTaxTypeCost.data.status === API_RESPONSE_CODES.OK) {
      setRoadTaxCost(roadTaxTypeCost?.data?.data);
      form.setFieldsValue({
        road_tax: roadTaxTypeCost?.data?.data,
      });
    }
  };

  const handleChangeForeclosure = (e) => {
    setForeClosure(e);
  };

  const calculateTotal = (values) => {
    const fields = [
      'ex_showroom_price',
      'tcs',
      'insurance',
      'cost_of_registration',
      'ew',
      'amc',
      'fastag',
      'body_care_3m',
      'logistic_charges',
      'road_tax',
      'tentative_accessories',
      'rto_cost',
      'handling_charges',
      'choice_number_charges',
    ];

    const totalSum = fields.reduce((sum, field) => {
      const value = parseFloat(values[field]) || 0;
      return sum + value;
    }, 0);

    const dealOffer = [
      'discount_approval_insurance',
      'consumer_offer',
      'exchange_offer',
      'corporate_offer',
      'other_oem_offer',
      'other_dealer_offer',
      'additional_discount',
    ];

    const totalSumOfDealOffer = dealOffer.reduce((sum, field) => {
      const value = parseFloat(values[field]) || 0;
      return sum + value;
    }, 0);

    let totalCustPayable = totalSum - totalSumOfDealOffer;

    let cutomer;
    if (values.customer_agree_to_exchange === 'Yes') {
      if (values.foreclosure_responsibility === 'Customer') {
        cutomer = values['value_offered'];
        const amount = totalCustPayable - cutomer;
        form.setFieldsValue({
          total_customer_payable: amount,
        });
        totalCustPayable = amount;
      } else if (values.foreclosure_responsibility === 'Dealer') {
        cutomer = values['value_offered'] - values['foreclosure_cost'];
        const amount = totalCustPayable - cutomer;
        form.setFieldsValue({
          total_customer_payable: amount,
        });
        totalCustPayable = amount;
      }
    } else if (values.customer_agree_to_exchange === 'No') {
      cutomer = 0;
      const amount = totalCustPayable - cutomer;
      totalCustPayable = amount;
      form.setFieldsValue({
        total_customer_payable: amount,
      });
    }

    setTotalCustomerPay(totalCustPayable);
    setTotalOffer(totalSumOfDealOffer);
    setTotal(totalSum);
  };

  const handleExShowroomChange = (e) => {
    const exShowroomPrice = parseFloat(e.target.value) || 0;

    // Check if the ex-showroom price is greater than 10 lakhs (1,000,000)
    if (exShowroomPrice > 1000000) {
      const calculatedTCS = (exShowroomPrice * 1) / 100; // 1% of ex showroom price
      setTcsValue(calculatedTCS); // Update the TCS value and round to 2 decimals
      form.setFieldsValue({ tcs: calculatedTCS }); // Set the TCS field value in the form
      calculateTotal(form.getFieldsValue());
    } else {
      setTcsValue(0); // Set TCS to 0 for values 10 lakhs or less
      form.setFieldsValue({ tcs: 0 }); // Update the TCS field in the form
      calculateTotal(form.getFieldsValue());
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      on_road_price: total,
      total_deal_offer: totalOffer,
      total_customer_payable: totalCustomerPay,
    });
  }, [total, form, totalOffer, totalCustomerPay]);

  const vehicleDataEntered =
    !excVehicleIds?.make_id ||
    !excVehicleIds?.model_id ||
    !excVehicleIds?.vehicle_variant_id ||
    !excVehicleIds?.color_type_id ||
    !excVehicleIds?.fuel_type_id ||
    !excVehicleIds?.seater_id;

  return (
    <>
      <Loader loading={isLoading} />
      {bookingDetailsShow || isExchangeEvaluationTeam || leadViewDetails?.lead_status?.name !== 'Open' ? (
        <BookingDetails
          editBooking={editBooking}
          setEditBooking={setEditBooking}
          setBookingDetailsShow={setBookingDetailsShow}
          isExchangeEvaluationTeam={isExchangeEvaluationTeam}
        />
      ) : (
        <div className='user-data lead-detail'>
          <Form
            form={form}
            layout='vertical'
            onFinish={onSubmit}
            onValuesChange={(_, values) => {
              calculateTotal(values);
            }}
          >
            <div className='basic-detail-wrapper'>
              <Row gutter={20}>
                <Col xl={12} lg={24} md={24} sm={24} xs={24}>
                  <div className='mb-3 me-3'>
                    <Title level={4} className='mb-3'>
                      Basic Details
                    </Title>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        Expected Date of Delivery <span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item
                          name='expected_delivery_date'
                          label=''
                          rules={[
                            {
                              required: true,
                              message: 'Please select any date',
                            },
                          ]}
                        >
                          <DatePicker
                            disabledDate={(current) => current && current < dayjs().startOf('day')}
                            format={dateFormat}
                            placeholder='Select Date'
                          />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>Choice of Vehicle Number</h6>
                      <div className='lead-input'>
                        <Form.Item
                          name='choice_vehicle_no'
                          label=''
                          rules={[
                            {
                              required: false,
                            },
                            {
                              pattern: /^[0-9]{4}$/,
                              message: 'Please enter a valid 4-digit vehicle number',
                            },
                          ]}
                        >
                          <Input placeholder='Choice of Vehicle Number' />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        RTO Location <span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <InputSelect
                          rules={[
                            {
                              required: true,
                              message: 'Please select RTO location',
                            },
                          ]}
                          className='form-control-ant'
                          name='rto_location_id'
                          placeholder='RTO Location'
                          options={rtoData}
                          optionName={'name'}
                          showSearch
                        />
                      </div>
                    </div>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>Social Occasion</h6>
                      <div className='lead-input'>
                        <Form.Item
                          name='social_occassion'
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                // Check if value is not provided or is only spaces
                                if (!value || value.trim().length === 0) {
                                  return Promise.resolve(); // Consider it valid if the field is empty
                                }

                                const trimmedValue = value.trim();
                                if (trimmedValue !== value) {
                                  return Promise.reject('Social occasion cannot start or end with spaces');
                                } else if (value.length > 80) {
                                  return Promise.reject(new Error('Please enter at most 80 characters'));
                                } else if (/\s{2,}/.test(value)) {
                                  return Promise.reject('Social occasion cannot contain two consecutive spaces');
                                } else if (!/^[a-zA-Z\s]*$/.test(value)) {
                                  return Promise.reject(new Error('Please enter only alphabets'));
                                } else {
                                  return Promise.resolve();
                                }
                              },
                            }),
                          ]}
                        >
                          <Input placeholder='Social Occasion' />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>Exchange</h6>
                      <div className='lead-input'>
                        <Form.Item
                          name='exchange_car'
                          label=''
                          rules={[
                            {
                              required: true,
                              message: 'Please select exchange',
                            },
                          ]}
                        >
                          <p>{leadViewDetails?.exchange_car ? leadViewDetails?.exchange_car : '-'}</p>
                          {/* <Select
                            className="form-control-ant"
                            placeholder="Yes/No"
                          >
                            <Select.Option value="Yes">Yes</Select.Option>
                            <Select.Option value="No">No</Select.Option>
                          </Select> */}
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xl={12} lg={24} md={24} sm={24} xs={24}>
                  {leadViewDetails?.exchange_car === 'Yes' && (
                    <div className='mb-3 ms-0'>
                      <Title level={4} className='mb-3'>
                        Exchange Related Details
                      </Title>
                      <div className='price-detail-wrap d-flex align-items-baseline'>
                        <h6>
                          Customer Agree to Exchange <span className='asterisk'>*</span>
                        </h6>
                        <div className='lead-input'>
                          <Form.Item
                            name='customer_agree_to_exchange'
                            label=''
                            rules={[
                              {
                                required: true,
                                message: 'Please select customer agree to exchange',
                              },
                            ]}
                          >
                            <Select
                              className='form-control-ant'
                              placeholder='Yes/No'
                              onChange={handleCustomerAgreeChange}
                            >
                              <Select.Option value='Yes'>Yes</Select.Option>
                              <Select.Option value='No'>No</Select.Option>
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                      <div className='price-detail-wrap d-flex align-items-baseline'>
                        <h6>Exchange Car</h6>
                        <div className='lead-input'>
                          <InputSelect
                            name='exchange_vehicle_model_id'
                            placeholder='Model'
                            options={modalData}
                            label=''
                            optionName={'model_name'}
                            showSearch
                            disabled
                          />
                        </div>
                      </div>
                      <div className='price-detail-wrap d-flex align-items-baseline'>
                        <h6>
                          Value Offered <span className='asterisk'>*</span>
                        </h6>
                        <div className='lead-input'>
                          <Form.Item name='value_offered' label=''>
                            <p>{formatIndianCurrency(leadViewDetails?.exchange_vehicle_detail?.value_offered) || 0}</p>
                            {/* <Input placeholder="Value Offered" /> */}
                          </Form.Item>
                        </div>
                      </div>
                      <div className='price-detail-wrap d-flex align-items-baseline'>
                        <h6>
                          Exchange Car Year <span className='asterisk'>*</span>
                        </h6>
                        <div className='lead-input'>
                          <Form.Item
                            name='year'
                            label=''
                            rules={[
                              {
                                required: true,
                                message: 'Please select year',
                              },
                            ]}
                          >
                            <DatePicker
                              picker='year'
                              disabledDate={(current) => {
                                return current && dayjs(current)?.isAfter(dayjs().endOf('year'), 'day');
                              }}
                              placeholder='Select Year'
                            />
                          </Form.Item>
                        </div>
                      </div>

                      <div className='price-detail-wrap d-flex align-items-baseline'>
                        <h6>
                          Odometer <span className='asterisk'>*</span>
                        </h6>
                        <div className='lead-input'>
                          <Form.Item
                            name='odometer'
                            label=''
                            rules={[
                              {
                                required: true,
                                validator: (_, value) => {
                                  if (!value) {
                                    return Promise.reject(new Error('Please input your odometer details'));
                                  }
                                  if (/\s/.test(value)) {
                                    return Promise.reject(new Error('The input must not contain whitespace'));
                                  }
                                  // Allow decimal values: up to 10 digits before decimal, then optional decimal part
                                  const decimalPattern = /^(\d{1,10})(\.\d+)?$/;
                                  if (!decimalPattern.test(value)) {
                                    return Promise.reject(new Error('The input must be numeric'));
                                  }
                                  // Extract the integer part (before decimal)
                                  const integerPart = value.split('.')[0];
                                  if (integerPart.length < 2) {
                                    return Promise.reject(new Error('The input must be at least 2 digits long'));
                                  }
                                  if (integerPart.length > 10) {
                                    return Promise.reject(new Error('Odometer reading cannot be more than 10 digits before decimal'));
                                  }
                                  return Promise.resolve();
                                },
                              },
                            ]}
                          >
                            <Input placeholder='Odometer' />
                          </Form.Item>
                        </div>
                      </div>
                      {showOdometer && (
                        <>
                          <div className='price-detail-wrap d-flex align-items-baseline'>
                            <h6>
                              Foreclosure Responsibility
                              <span className='asterisk'>*</span>
                            </h6>
                            <div className='lead-input'>
                              <Form.Item
                                name='foreclosure_responsibility'
                                label=''
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please select foreclosure responsibility',
                                  },
                                ]}
                              >
                                <Select
                                  className='form-control-ant'
                                  placeholder='Foreclosure Responsibility'
                                  onChange={(e) => handleChangeForeclosure(e)}
                                  allowClear
                                >
                                  <Select.Option value='Customer'>Customer</Select.Option>
                                  <Select.Option value='Dealer'>Dealer</Select.Option>
                                </Select>
                              </Form.Item>
                            </div>
                          </div>
                          <div className='price-detail-wrap d-flex align-items-baseline'>
                            <h6>
                              Hypothecation on Car <span className='asterisk'>*</span>
                            </h6>
                            <div className='lead-input'>
                              <Form.Item
                                name='hypothecation_on_care'
                                label=''
                                rules={[
                                  {
                                    required: true,
                                    message: '',
                                  },
                                  ({ getFieldValue }) => ({
                                    validator(_, value) {
                                      if (!value) {
                                        return Promise.reject('Please input your Hypothecation on Car');
                                      }
                                      if (!/^[A-Za-z\s]+$/.test(value)) {
                                        return Promise.reject('Please input a valid Hypothecation on Car');
                                      }
                                      if (/\s{2,}/.test(value)) {
                                        return Promise.reject('Cannot contain two consecutive spaces');
                                      }
                                      const trimmedValue = value.trim();
                                      if (trimmedValue !== value) {
                                        return Promise.reject('Cannot start or end with spaces');
                                      }
                                      if (value?.length < 3 || value?.length > 30) {
                                        return Promise.reject(
                                          'Hypothecation on Car must be between 3 and 30 characters'
                                        );
                                      }
                                      return Promise.resolve();
                                    },
                                  }),
                                ]}
                              >
                                <Input placeholder='Hypothecaton on Car ' />
                              </Form.Item>
                            </div>
                          </div>
                          <div className='price-detail-wrap d-flex align-items-baseline'>
                            <h6>Foreclosure Cost</h6>
                            <div className='lead-input'>
                              <Form.Item
                                name='foreclosure_cost'
                                label=''
                                rules={notRequiredPriceValidationFunction('Foreclosure Cost')}
                              >
                                <Input placeholder='Foreclosure Cost' />
                              </Form.Item>
                            </div>
                          </div>
                          <div className='price-detail-wrap d-flex align-items-baseline'>
                            <h6>
                              Vehicle Handed Over to Exchange Team <span className='asterisk'>*</span>
                            </h6>
                            <div className='lead-input'>
                              <Form.Item
                                name='vehicle_handed_over_to_exchange_team'
                                label=''
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please select vehicle handed over to exchange team',
                                  },
                                ]}
                              >
                                <Select className='form-control-ant' placeholder='Yes/No'>
                                  <Select.Option value='Yes'>Yes</Select.Option>
                                  <Select.Option value='No'>No</Select.Option>
                                </Select>
                              </Form.Item>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </Col>
                <Col xl={12} lg={24} md={24} sm={24} xs={24}>
                  <div className='mb-3 ms-0'>
                   
                    <Title level={4} className='mb-3'>
                      Car Details
                    </Title>
                    <BookingDropdowns
                      form={form}
                      setIsLoading={setIsLoading}
                      excVehicleIds={excVehicleIds}
                      leadViewDetails={leadViewDetails}
                      setExcVehicleIds={setExcVehicleIds}
                    />
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        EX-Showroom <span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item
                          name='ex_showroom_price'
                          label=''
                          rules={priceValidationFunction('Ex-Showroom price')}
                        >
                          <Input placeholder='Ex-Showroom Price' onChange={handleExShowroomChange} />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        TCS<span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item name='tcs' label='' rules={priceValidationFunction('TCS')}>
                          <Input placeholder='TCS' value={tcsValue} readOnly />
                        </Form.Item>
                      </div>
                    </div>
                    {/* Insurance Type */}
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        Insurance Type <span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item
                          label=''
                          name='insurance_type_id'
                          rules={[
                            {
                              required: true,
                              message: 'Please select your insurance type ',
                            },
                          ]}
                        >
                          <Select
                            placeholder='Insurance Type'
                            disabled={vehicleDataEntered}
                            onChange={handleInsuranceTypeChange}
                          >
                            {insuranceTypeData?.map((option) => (
                              <Select.Option key={option.id} value={option.id}>
                                {option.type}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    {/* Insurance */}
                    {!isNaN(insuranceCost) && !vehicleDataEntered ? (
                      <div className='price-detail-wrap d-flex align-items-baseline'>
                        <h6>
                          Insurance <span className='asterisk'>*</span>
                        </h6>
                        <div className='lead-input'>
                          {/* <Form.Item label='' name='insurance' rules={priceValidationFunction('Insurance')}>
                            <p>{insuranceCost ? formatIndianCurrency(insuranceCost) : '-'}</p>
                          </Form.Item> */}
                          <Form.Item name='insurance' label='' rules={priceValidationFunction('Insurance')}>
                            <Input placeholder='Insurance' />
                          </Form.Item>
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        RTO Cost<span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item label='' name='rto_cost' rules={priceValidationFunction('RTO Cost')}>
                          <Input placeholder='RTO Cost' />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        Cost of Registration<span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item
                          label=''
                          name='cost_of_registration'
                          rules={priceValidationFunction('Cost of Registration')}
                        >
                          <Input placeholder='Cost of Registration' />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        Extended Warranty <span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item name='ew' label='' rules={priceValidationFunction('Extended Warranty')}>
                          <Input placeholder='Extended Warranty' />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>AMC</h6>
                      <div className='lead-input'>
                        <Form.Item name='amc' label='' rules={notRequiredPriceValidationFunction('AMC')}>
                          <Input placeholder='AMC' />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        Tentative Accessories <span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item
                          name='tentative_accessories'
                          label=''
                          rules={priceValidationFunction('Tentative Accessories')}
                        >
                          <Input placeholder='Tentative Accessories' />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        Fastag <span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item name='fastag' label='' rules={priceValidationFunction('Fastag')}>
                          <Input placeholder='Fastag' />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        T-Gloss <span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item name='body_care_3m' label='' rules={priceValidationFunction('T-Gloss')}>
                          <Input placeholder='T-Gloss' />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        Other Logistcs Charges <span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item name='logistic_charges' label='' rules={priceValidationFunction('Logistcs Charges')}>
                          <Input placeholder='Other Logistcs Charges' />
                        </Form.Item>
                      </div>
                    </div>
                    {/* Road Tax Type */}
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        Road Tax Type <span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item
                          label=''
                          name='road_tax_type_id'
                          rules={[
                            {
                              required: true,
                              message: 'Please select your road tax type ',
                            },
                          ]}
                        >
                          <Select
                            placeholder='Road Tax Type'
                            disabled={vehicleDataEntered}
                            onChange={handleRoadTaxTypeChange}
                          >
                            {roadTaxTypeData?.map((option) => (
                              <Select.Option key={option.id} value={option.id}>
                                {option.type}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </div>
                    {/* Road Tax */}
                    {!isNaN(roadTaxCost) && !vehicleDataEntered ? (
                      <div className='price-detail-wrap d-flex align-items-baseline'>
                        <h6>
                          Road Tax <span className='asterisk'>*</span>
                        </h6>
                        <div className='lead-input'>
                          <Form.Item name='road_tax' label='' rules={priceValidationFunction('Road Tax')}>
                            <p>{roadTaxCost ? formatIndianCurrency(roadTaxCost) : '-'}</p>
                          </Form.Item>
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        Handling Charges <span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item name='handling_charges' label='' rules={priceValidationFunction('Handling Charges')}>
                          <Input placeholder='Handling Charges' />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        Choice Number Charges <span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item name='choice_number_charges' label='' rules={priceValidationFunction('Choice Number Charges')}>
                          <Input placeholder='Choice Number Charges' />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        On Road Price <span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item
                          name='on_road_price'
                          label=''
                          rules={[
                            {
                              required: true,
                              message: 'Please input on road price ',
                            },
                          ]}
                        >
                          <Input placeholder='On Road Price' value={total} readOnly />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>Insurance Company</h6>
                      <div className='lead-input'>
                        <Form.Item name='insurance_company' label='' rules={[{ required: false }]}>
                          <Input placeholder='Insurance Company' />
                        </Form.Item>
                      </div>
                    </div>

                  </div>
                </Col>
                <Col xl={12} lg={24} md={24} sm={24} xs={24}>
                  <div className='mb-3 me-3'>
                    <Title level={4} className='mb-3'>
                      Deal Related Details
                    </Title>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        Discount Approval Insurance <span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item
                          name='discount_approval_insurance'
                          label=''
                          rules={priceValidationFunction('Discount Approval Insurance')}
                        >
                          <Input placeholder='Discount Approval Insurance' />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        Consumer Offer <span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item name='consumer_offer' label='' rules={priceValidationFunction('Consumer Offer')}>
                          <Input placeholder='Consumer Offer' />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        Exchange Offer<span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item name='exchange_offer' label='' rules={priceValidationFunction('Exchange Offer')}>
                          <Input placeholder='Exchange Offer' />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        Corporate Offer <span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item name='corporate_offer' label='' rules={priceValidationFunction('Corporate Offer')}>
                          <Input placeholder='Corporate Offer' />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        Other OEM Offer <span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item name='other_oem_offer' label='' rules={priceValidationFunction('Other OEM Offer')}>
                          <Input placeholder='Other OEM Offer' />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        Other Dealer Offer <span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item
                          name='other_dealer_offer'
                          label=''
                          rules={priceValidationFunction('Other Dealer Offer')}
                        >
                          <Input placeholder='Other Dealer Offer' />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        Additional Discount <span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item
                          name='additional_discount'
                          label=''
                          rules={[
                            {
                              required: true,
                              message: 'Please enter additional discount',
                            },
                            {
                              validator: (_, value) => {
                                // if (value === null || value === undefined || value === '') {
                                //   return Promise.reject('Please enter additional discount');
                                // }
                                const numValue = parseFloat(value);

                                if (numValue < 0 || numValue > 1000000) {
                                  return Promise.reject('Additional Discount must be between ₹0 to ₹10,00,000');
                                }
                                return Promise.resolve();
                              },
                            },
                          ]}
                        >
                          <Input
                            placeholder='Enter Additional Discount (₹0 - ₹10,00,000)'
                            type='number'
                          />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        Total Deal Offer <span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item name='total_deal_offer' label='' rules={priceValidationFunction('Total Deal Offer')}>
                          <Input placeholder='Total Deal Offer' value={totalOffer} readOnly />
                        </Form.Item>
                      </div>
                    </div>
                    <div className='price-detail-wrap d-flex align-items-baseline'>
                      <h6>
                        Total Customer Payable <span className='asterisk'>*</span>
                      </h6>
                      <div className='lead-input'>
                        <Form.Item
                          name='total_customer_payable'
                          label=''
                          rules={[
                            {
                              required: true,
                              message: 'Please input total amount payable',
                            },
                            // {
                            //   validator: (_, value) =>
                            //     value <= 0
                            //       ? Promise.reject(new Error('The Total Amount Payable should be a valid price'))
                            //       : Promise.resolve(),
                            // },
                          ]}
                        // rules={priceValidationFunction(
                        //   "Total Customer Payable"
                        // )}
                        >
                          <Input placeholder='Total Customer Payable' value={totalCustomerPay} readOnly />
                        </Form.Item>
                      </div>
                    </div>

                  </div>
                  <div className='mb-3 me-3'>
                    <Title level={4} className='mb-3'>
                      Image Upload
                    </Title>
                    <Row gutter={[16, 12]} align='middle' className='mb-3'>
                      <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                        <div className='lead-input'>
                          <Form.Item name='copy_of_rc' layout='horizontal' className='mb-0'>
                            <UploadButton
                              name='copy_of_rc'
                              // documentType="copy_of_rc"
                              fileList={fileList}
                              setFileList={setFileList}
                              fileType={['image/jpeg', 'image/png']}
                              fileSizeLimit={5}
                              label='RC Copy'
                            />
                          </Form.Item>
                        </div>
                      </Col>
                      <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                        <div className='lead-input'>
                          <Form.Item name='copy_of_insurance' layout='horizontal' className='mb-0'>
                            <UploadButton
                              name='copy_of_insurance'
                              // documentType="copy_of_insurance"
                              fileList={fileList}
                              setFileList={setFileList}
                              fileType={['image/jpeg', 'image/png']}
                              fileSizeLimit={5}
                              label='Old Car Insurance Copy'
                            />
                          </Form.Item>
                        </div>
                      </Col>
                      <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                        <div className='lead-input'>
                          <Form.Item name='copy_of_foreclosure_statement' layout='horizontal' className='mb-0'>
                            <UploadButton
                              name='copy_of_foreclosure_statement'
                              // documentType="copy_of_foreclosure_statement"
                              fileList={fileList}
                              setFileList={setFileList}
                              fileType={['image/jpeg', 'image/png']}
                              fileSizeLimit={5}
                              label='Old Car Foreclosure Statement'
                            />
                          </Form.Item>
                        </div>
                      </Col>
                      <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                        <div className='lead-input'>
                          <Form.Item name='copy_of_mr' layout='horizontal' className='mb-0'>
                            <UploadButton
                              name='copy_of_mr'
                              // documentType="copy_of_mr"
                              fileList={fileList}
                              setFileList={setFileList}
                              fileType={['image/jpeg', 'image/png']}
                              fileSizeLimit={5}
                              label='MR Copy'
                            />
                          </Form.Item>
                        </div>
                      </Col>
                      <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                        <div className='lead-input'>
                          <Form.Item name='copy_of_order_booklet' layout='horizontal' className='mb-0'>
                            <UploadButton
                              name='copy_of_order_booklet'
                              fileList={fileList}
                              setFileList={setFileList}
                              fileType={['image/jpeg', 'image/png']}
                              fileSizeLimit={5}
                              label='Order Booklet Copy'
                            // documentType="copy_of_order_booklet"
                            />
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>

              </Row>
              <div className='user-right d-flex align-items-center justify-content-end flex-md-wrap '>
                <Button type='primary' ghost danger className='primary-button' onClick={handleCancel}>
                  Cancel
                </Button>

                <Button
                  type='primary'
                  className='secondary-button ms-3'
                  htmlType='submit'
                  onClick={() =>
                    leadViewDetails?.booking?.status === 'Booked'
                      ? handleStatusTracker('Booked')
                      : handleStatusTracker('Save')
                  }
                >
                  {editBooking ? 'Update' : 'Save'}
                </Button>

                {leadViewDetails?.booking?.status !== 'Booked' && (
                  <Button
                    type='primary'
                    className='secondary-button mt-md-0 ms-md-3 ms-3'
                    onClick={() => {
                      // Directly mark as Booked and submit the form (API will run),
                      // then after success we'll show the confirmation from onSubmit.
                      handleStatusTracker('Booked');
                      form.submit();
                    }}
                  >
                    Book
                  </Button>
                )}
              </div>
            </div>
          </Form>
        </div>
      )}

      {/* Transaction Modal for adding booking amount */}
      <TransactionModal
        leadId={id}
        open={isTransactionModalOpen}
        onCancel={() => {
          setIsTransactionModalOpen(false);
          transactionForm.resetFields();
          setTransactionFile([]);
          setBookingDetailsShow(true);
          if (typeof setEditBooking === 'function') {
            setEditBooking(false);
          }
        }}
        form={transactionForm}
        onFinish={async (values) => {
          if (isTransactionSaveLoading) return;
          setIsTransactionSaveLoading(true);
          try {
            const formData = new FormData();
            formData.append('lead_id', id);
            formData.append('payment_type', values.payment_for);
            if (values.transaction_mode) {
              formData.append('transaction_mode', values.transaction_mode);
            }
            if (values.reverses_transaction_id != null && values.reverses_transaction_id !== '') {
              formData.append('reverses_transaction_id', values.reverses_transaction_id);
            }
            formData.append('amount', values.amount);
            formData.append('payment_mode', values.payment_mode);
            formData.append('payment_date', values.date_of_payment.format('YYYY-MM-DD'));
            if (values.mr_utr_number) {
              formData.append('mr_utr_number', values.mr_utr_number);
            }
            if (values.remarks) {
              formData.append('remarks', values.remarks);
            }

            // Reversal entry attachment handling:
            // - default file: send URL path
            // - newly selected file: send binary
            // - deleted file: send empty string
            if (values.transaction_mode === 'reversal') {
              if (transactionFile?.length > 0) {
                const fileToUpload = transactionFile.find((f) => f.originFileObj);
                if (fileToUpload?.originFileObj) {
                  formData.append('document', fileToUpload.originFileObj);
                } else if (transactionFile?.[0]?.url) {
                  formData.append('document', transactionFile[0].url);
                }
              } else {
                formData.append('document', '');
              }
            } else if (transactionFile?.length > 0) {
              // Existing behavior for non-reversal entries.
              const fileToUpload = transactionFile.find((f) => f.originFileObj);
              if (fileToUpload?.originFileObj) {
                formData.append('document', fileToUpload.originFileObj);
              }
            }

            await addPaymentTransactionService(formData);
            notification.success({
              message: 'Transaction saved successfully',
            });
            setIsTransactionModalOpen(false);
            transactionForm.resetFields();
            setTransactionFile([]);
            dispatch(fetchLeadDetailsServices({ id }));
            // After saving transaction from booking, go to Payments tab
            dispatch(handleTabChange('payments'));
          } catch (error) {
            notification.error({
              description: error?.response?.data?.message || error?.message,
            });
          } finally {
            setIsTransactionSaveLoading(false);
          }
        }}
        isEditTransaction={false}
        isLeadOpen={true}
        isRefundEnabled={false}
        saveLoading={isTransactionSaveLoading}
        fixedPaymentType="Booking"
        transactionFile={transactionFile}
        onTransactionFileChange={(info) => setTransactionFile([...info.fileList])}
        validateTransactionFile={(file) => {
          const isValidType =
            file.type === 'image/jpeg' ||
            file.type === 'image/png' ||
            file.type === 'image/gif' ||
            file.type === 'application/pdf';
          if (!isValidType) {
            notification.error({
              description: 'You can only upload JPG/PNG/GIF/PDF file',
            });
            return Upload.LIST_IGNORE;
          }
          const isLt5M = file.size / 1024 / 1024 < 5;
          if (!isLt5M) {
            notification.error({
              description: 'File must be smaller than 5MB',
            });
            return Upload.LIST_IGNORE;
          }
          return true;
        }}
      />
    </>
  );
};

export default Bookings;
